import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    duyet: { //object, optional // Thông tin duyệt
        duoc_duyet: null, //boolean, optional // Cho biết điểm đến đã được duyệt hay chưa
        thoi_diem_duoc_duyet: null, //datetime, optional // Cho biết thời điểm điểm đến đã được duyệt
        nguoi_duyet_id: null, //IdRef, optional // Mã người duyệt
    },
    loai_diem_den: null, //string, optional // Loại điểm đến
    thong_tin_chung: { //object, optional // Thông tin chung
        ten: null, //string, optional // Tên điểm đến
        anh: null, //IdRef, optional // Mã ảnh đại diện
        giay_to: {}, //object, optional // Thông tin giấy tờ định danh điểm đến
        dia_chi: {}, //object, optional // Thông tin địa chỉ
        nguoi_dai_dien: {}, //object, optional // Thông tin người đại diện
    },
    hoat_dong: { // optional Thông tin hoạt động
        ngung_hoat_dong: null, // optional Cho biết đơn vị có đang ngừng hoạt động hay không. Mặc định là đang hoạt động
        thoi_diem_thay_doi_cuoi: null, // optional Thời điểm ngừng hoạt động/hoạt động trở lại (gần nhất)
    },
    du_lieu_khai_bao: {}, //object, optional // Dữ liệu khai báo khi đăng ký điểm đến
    nguoi_tao_id: null, //IdRef, optional // Mã người tạo
    thoi_diem_tao: null, //datetime, optional // Thời điểm tạo
    album: [ // optional Album ảnh của điểm đến
    {
        ngon_ngu: undefined, // required Ngôn ngữ hiển thị
        anh_id: undefined, // required Id của ảnh hiển thị
        tieu_de: undefined, // optional Tiêu đề của ảnh
    }],
    noi_dung_hien_thi:[  // optional Nội dung hiển thị
        {
            ngon_ngu: undefined, // required Ngôn ngữ hiển thị
            gioi_thieu: undefined, // required Giới thiệu thông tin
            anh_id: undefined, // optional Id của ảnh hiển thị
            noi_dung: undefined, // required Nội dung hiển thị
        }
    ],
    ngon_ngu: "vi",
    noiDungHienThiFilter: {
        gioi_thieu: undefined,
        anh_id: undefined,
        noi_dung: undefined,
    },
    listImageUrl: {
        anh_id: undefined,
        tieu_de: undefined,
        ngon_ngu: undefined,
        type: undefined
    },
    albumAnhFilter: {
        anh_id:undefined
    }
};

// validation form
model.validForm = {
    duyet: { //object, optional // Thông tin duyệt
        duoc_duyet: [], //boolean, optional // Cho biết điểm đến đã được duyệt hay chưa
        thoi_diem_duoc_duyet: [], //datetime, optional // Cho biết thời điểm điểm đến đã được duyệt
        nguoi_duyet_id: [], //IdRef, optional // Mã người duyệt
    },
    loai_diem_den: [], //string, optional // Loại điểm đến
    thong_tin_chung: { //object, optional // Thông tin chung
        ten: [], //string, optional // Tên điểm đến
        anh: [], //IdRef, optional // Mã ảnh đại diện
    },
    du_lieu_khai_bao: [], //object, optional // Dữ liệu khai báo khi đăng ký điểm đến
    nguoi_tao_id: [], //IdRef, optional // Mã người tạo
    thoi_diem_tao: [], //datetime, optional // Thời điểm tạo

};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    giay_to: { //object, optional // Thông tin giấy tờ định danh điểm đến
        so_giay_to: null, //string, optional // Mã số thuế/Mã số doanh nghiệp
        noi_cap: null, //string, optional // Nơi cấp
        ngay_cap: null, //datetime, optional // Ngày cấp
        scan: [], //array of IdRef, optional // Danh sách mã ảnh scan
        dia_chi: null, //string, optional // Địa chỉ trên đăng ký kinh doanh
    },
    dia_chi: { //object, optional // Thông tin địa chỉ
        quoc_gia: null, //string, optional // Quốc gia
        quoc_tich_id: null, //IdRef, optional // Mã quốc tịch
        tinh: null, //string, optional // Tên tỉnh
        tinh_id: null, //IdRef, optional // Mã tỉnh
        xa: null, //string, optional // Tên xa
        xa_id: null, //IdRef, optional // Mã xã
        dia_chi: null, //string, optional // Địa chỉ giao dịch
        kinh_do: null, //double, optional // Kinh độ
        vi_do: null, //double, optional // Vĩ độ
    },
    nguoi_dai_dien: { //object, optional // Thông tin người đại diện
        ho_ten: null, //string, optional // Họ và tên
        chuc_vu: null, //string, optional // Chức vụ
        ngay_sinh: null, //datetime, optional // Ngày sinh
        so_giay_to: null, //string, optional // Số CMT/ Căn cước/ Hộ chiếu
        gioi_tinh: null, //integer, optional // Giới tính
        dia_chi: null, //string, optional // Địa chỉ
        dien_thoai: null, //string, optional // Điện thoại
        email: null, //string, optional // Email
    },
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhGiayTo: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};

// validation các form khác
model.validFormOther = {
    giay_to: { //object, optional // Thông tin giấy tờ định danh điểm đến
        so_giay_to: [], //string, optional // Mã số thuế/Mã số doanh nghiệp
        noi_cap: [], //string, optional // Nơi cấp
        ngay_cap: [], //datetime, optional // Ngày cấp
        scan: [], //array of IdRef, optional // Danh sách mã ảnh scan
        dia_chi: [], //string, optional // Địa chỉ trên đăng ký kinh doanh
    },
    dia_chi: { //object, optional // Thông tin địa chỉ
        quoc_gia: [], //string, optional // Quốc gia
        quoc_tich_id: [], //IdRef, optional // Mã quốc tịch
        tinh: [], //string, optional // Tên tỉnh
        tinh_id: [], //IdRef, optional // Mã tỉnh
        xa: [], //string, optional // Tên xa
        xa_id: [], //IdRef, optional // Mã xã
        dia_chi: [], //string, optional // Địa chỉ giao dịch
        kinh_do: [], //double, optional // Kinh độ
        vi_do: [], //double, optional // Vĩ độ
    },
    nguoi_dai_dien: { //object, optional // Thông tin người đại diện
        ho_ten: [], //string, optional // Họ và tên
        chuc_vu: [], //string, optional // Chức vụ
        ngay_sinh: [], //datetime, optional // Ngày sinh
        so_giay_to: [], //string, optional // Số CMT/ Căn cước/ Hộ chiếu
        gioi_tinh: [], //integer, optional // Giới tính
        dia_chi: [], //string, optional // Địa chỉ
        dien_thoai: [], //string, optional // Điện thoại
        email: [], //string, optional // Email
    }
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "-thoi_diem_tao",
    defaultSort: ["thoi_diem_tao", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            'duyet.duoc_duyet': '',
            loai_diem_den: '',
            'thong_tin_chung.ten': '',
            'du_lieu_khai_bao.user_account': '',
            'thong_tin_chung.giay_to.so_giay_to': '',
            nguoi_tao_id: '',
            thoi_diem_tao: '',
            "thong_tin_chung.dia_chi.tinh_id": null, // optional Mã tỉnh
            "thong_tin_chung.dia_chi.xa_id": null,
            'thong_tin_chung.nguoi_dai_dien.dien_thoai': '',
            'hoat_dong.ngung_hoat_dong': ''
        },
        valid: {
            'duyet.duoc_duyet': [],
            loai_diem_den: [],
            'thong_tin_chung.ten': [],
            'du_lieu_khai_bao.user_account': [],
            nguoi_tao_id: [],
            thoi_diem_tao: [],
            thong_tin_chung: {
                dia_chi: {
                    "tinh_id": null, // optional Mã tỉnh
                    "xa_id": null,
                }
            },
            'thong_tin_chung.nguoi_dai_dien.dien_thoai': [],
            'hoat_dong.ngung_hoat_dong': [],
        },
        operator: {
            'thong_tin_chung.ten': "$vn_text=", //:regex:, $vn_text=Viêt nam
            'du_lieu_khai_bao.user_account': ":regex_i:",
            'thong_tin_chung.giay_to.so_giay_to': ":regex_i:",
            thoi_diem_tao: ":in_that_day:",
            'thong_tin_chung.nguoi_dai_dien.dien_thoai': '',
            'hoat_dong.ngung_hoat_dong': ''
        }
    }
};

export default model;
